import { EnumShareType } from 'src/dict/dictEnum';

/** 用户操作类型 */
export enum EnumOperateType {
  /** 查看/下载 */
  download = 1,
  /** 仅可查看 */
  view = 2,
  /** 管理 */
  manage = 3,
}

/** 分享模态框类型，分享看板，分享图表 */
export type ShareModalType = 'dashbord' | 'chart';

export interface ShareUser {
  user_id: number;
  name: string;
  operate_type: EnumOperateType;
  // 工号/学号
  username?: string;
}

/** 图表/看板/分析报告分享详情 */
export interface ShareInfo {
  id: number;
  chart_id: number;
  dashboard_id: number;
  report_id: string;
  operate_type?: EnumOperateType;
  share_type: EnumShareType;
  share_user: ShareUser[];
  url: string;
}

/** 图表/看板/分析报告分享的表单数据 */
export interface ShareFormData
  extends Pick<Partial<ShareInfo>, 'id'>,
    Omit<ShareInfo, 'id'> {
  share_type: EnumShareType;
}
